module.exports = "<img [src]=\"getProductImg()\">\n<span class=\"kt-font-bold\">\n  {{productName}}</span>"